import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './SincronizacionContifico.css'; 

const SincronizacionContifico = () => {
    const [settings, setSettings] = useState({
        api_key: '',
        pos_token: '',
        base_url: '',
        is_active: false
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [syncStats, setSyncStats] = useState(null);
    const [bankAccounts, setBankAccounts] = useState([]);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await api.get('/api/integrations/contifico/settings/');
            setSettings(response.data);
        } catch (error) {
            console.error('Error fetching settings:', error);
            setMessage({ text: 'Error cargando configuración', type: 'error' });
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setSettings(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSaveAndTest = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage({ text: '', type: '' });
        
        try {
            const response = await api.post('/api/integrations/contifico/test/', settings);
            setMessage({ text: response.data.message || 'Conexión exitosa', type: 'success' });
            // Refrescar configuración guardada
            fetchSettings();
        } catch (error) {
            setMessage({ 
                text: error.response?.data?.message || 'Error al probar conexión', 
                type: 'error' 
            });
            // Refrescar la configuración guardada aunque la prueba falle
            fetchSettings();
        } finally {
            setLoading(false);
        }
    };

    const handleSync = async () => {
        setLoading(true);
        setMessage({ text: 'Sincronizando productos... esto puede tomar un momento.', type: 'info' });
        setSyncStats(null);
        
        try {
            const response = await api.post('/api/integrations/contifico/sync-products/');
            setMessage({ text: response.data.message || 'Sincronización completa', type: 'success' });
            setSyncStats(response.data);
        } catch (error) {
            setMessage({ 
                text: error.response?.data?.message || 'Error en sincronización', 
                type: 'error' 
            });
        } finally {
            setLoading(false);
        }
    };

    const handleFetchBanks = async () => {
        try {
            setMessage({ text: 'Consultando cuentas bancarias...', type: 'info' });
            const response = await api.get('/api/integrations/contifico/bank-accounts/');
            if (response.data.accounts && response.data.accounts.length > 0) {
                setBankAccounts(response.data.accounts);
                setMessage({ text: 'Cuentas consultadas exitosamente. Selecciona una en el listado.', type: 'success' });
            } else {
                alert('No hay cuentas bancarias configuradas en tu cuenta de Contífico.');
                setMessage({ text: '', type: '' });
            }
        } catch (error) {
            setMessage({ 
                text: error.response?.data?.message || 'Error al consultar cuentas bancarias', 
                type: 'error' 
            });
        }
    };

    return (
        <div style={{ flex: 1, padding: '24px' }}>
            <h1 style={{ marginBottom: '24px', color: 'var(--primary-color)' }}>Centro de Sincronización - Contífico</h1>
            <div className="content-padding">
                <div className="settings-card">
                    <h3>Configuración de API</h3>
                    {message.text && (
                        <div className={`alert alert-${message.type}`}>
                            {message.text}
                        </div>
                    )}
                    <form onSubmit={handleSaveAndTest} className="sync-form">
                        <div className="form-group">
                            <label>URL Base de Contífico</label>
                            <input
                                type="url"
                                name="base_url"
                                value={settings.base_url || ''}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="https://api.contifico.com/sistema/api/v1/"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>API Key</label>
                            <input
                                type="password"
                                name="api_key"
                                value={settings.api_key || ''}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingrese su API Key de Contífico"
                            />
                        </div>
                        <div className="form-group">
                            <label>POS Token (Para Facturación)</label>
                            <input
                                type="password"
                                name="pos_token"
                                value={settings.pos_token || ''}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingrese su POS Token"
                            />
                        </div>
                        <div className="form-group">
                            <label>ID Cuenta Bancaria (Para pagos con Transferencia)</label>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                {bankAccounts.length > 0 ? (
                                    <select
                                        name="cuenta_bancaria_id"
                                        value={settings.cuenta_bancaria_id || ''}
                                        onChange={handleChange}
                                        className="form-control"
                                    >
                                        <option value="">-- Seleccione una cuenta --</option>
                                        {bankAccounts.map(acc => (
                                            <option key={acc.id} value={acc.id}>
                                                {acc.nombre} ({acc.numero})
                                            </option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        type="text"
                                        name="cuenta_bancaria_id"
                                        value={settings.cuenta_bancaria_id || ''}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Clic en Consultar IDs para cargar"
                                    />
                                )}
                                <button type="button" className="btn btn-secondary" onClick={handleFetchBanks} style={{ whiteSpace: 'nowrap', backgroundColor: '#4b5563', border: 'none', color: 'white', padding: '0 15px', borderRadius: '4px', cursor: 'pointer' }}>
                                    Consultar IDs
                                </button>
                            </div>
                            <small style={{ color: 'rgba(255,255,255,0.5)', display: 'block', marginTop: '5px' }}>Dale clic a "Consultar IDs" para cargar tus cuentas bancarias y selecciona una.</small>
                        </div>
                        <div className="form-group checkbox-group">
                            <label>
                                <input
                                    type="checkbox"
                                    name="is_active"
                                    checked={settings.is_active || false}
                                    onChange={handleChange}
                                />
                                Habilitar Integración con Contífico
                            </label>
                        </div>

                        <hr style={{margin: '20px 0', borderColor: 'rgba(255,255,255,0.1)'}}/>
                        <h4>Configuración de Facturación SRI</h4>
                        
                        <div className="form-group checkbox-group">
                            <label>
                                <input
                                    type="checkbox"
                                    name="emitir_sri"
                                    checked={settings.emitir_sri || false}
                                    onChange={handleChange}
                                />
                                Habilitar Emisión Electrónica SRI (Cuidado en Producción)
                            </label>
                        </div>
                        
                        <div style={{display: 'flex', gap: '15px'}}>
                            <div className="form-group" style={{flex: 1}}>
                                <label>Establecimiento</label>
                                <input
                                    type="text"
                                    name="establecimiento"
                                    value={settings.establecimiento || '003'}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="003"
                                    maxLength="3"
                                />
                            </div>
                            <div className="form-group" style={{flex: 1}}>
                                <label>Punto Emisión (Facturas SRI)</label>
                                <input
                                    type="text"
                                    name="punto_emision"
                                    value={settings.punto_emision || '001'}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="001"
                                    maxLength="3"
                                />
                            </div>
                            <div className="form-group" style={{flex: 1}}>
                                <label>Próximo Secuencial (Facturas)</label>
                                <input
                                    type="number"
                                    name="secuencial_factura"
                                    value={settings.secuencial_factura || 1}
                                    onChange={handleChange}
                                    className="form-control"
                                    min="1"
                                />
                            </div>
                        </div>

                        <hr style={{margin: '20px 0', borderColor: 'rgba(255,255,255,0.1)'}}/>
                        <h4>Configuración de Notas de Entrega (Internas)</h4>
                        <p style={{fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)', marginBottom: '15px'}}>
                            Las Notas de Entrega usan un punto de emisión y secuencial separado para no crear huecos en la numeración SRI.
                        </p>

                        <div style={{display: 'flex', gap: '15px'}}>
                            <div className="form-group" style={{flex: 1}}>
                                <label>Punto Emisión (Notas Internas)</label>
                                <input
                                    type="text"
                                    name="punto_emision_nota"
                                    value={settings.punto_emision_nota || '002'}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="002"
                                    maxLength="3"
                                />
                            </div>
                            <div className="form-group" style={{flex: 1}}>
                                <label>Próximo Secuencial (Notas)</label>
                                <input
                                    type="number"
                                    name="secuencial_nota_venta"
                                    value={settings.secuencial_nota_venta || 1}
                                    onChange={handleChange}
                                    className="form-control"
                                    min="1"
                                />
                            </div>
                            <div className="form-group" style={{flex: 1}}>
                                {/* Spacer */}
                            </div>
                        </div>

                        <div className="form-actions mt-3">
                            <button 
                                type="submit" 
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading ? 'Procesando...' : 'Guardar y Probar Conexión'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SincronizacionContifico;
